import React from "react";
import { useNavigate } from "react-router-dom";
import type { ClassData } from "../../../interfaces/classSessions";
import { useLocalization } from "../../../stores/localizationContext";
import { deriveScheduleString } from "../../../utils/earningsUtils";
import "./List.scss";

interface ListProps {
  classes?: ClassData[];
}

const List: React.FC<ListProps> = ({ classes = [] }) => {
  const { t, lang } = useLocalization();
  const navigate = useNavigate();
  const locale = lang === "ar" ? "ar-EG" : "en-US";

  return (
    <>
      {classes.map((classItem) => (
        <a
          href="#"
          key={classItem.class_id}
          className="list__item"
          onClick={(e) => {
            e.preventDefault();
            navigate(`/${lang}/classes/${classItem.class_id}/sessions`);
          }}
        >
          <div className="list__item__icon">
            <img
              src={classItem.class_subjects?.[0]?.subject_icon || ""}
              alt={classItem.class_subjects?.[0]?.subject_name || ""}
            />
          </div>
          <div className="list__item__details">
            <div className="title">
              <h2>{classItem.class_title}</h2>
            </div>
            <div className="details">
              <p>
                {classItem.class_subjects?.[0]?.subject_name || ""}
                {classItem.class_semester_localization_key
                  ? ` • ${t(classItem.class_semester_localization_key, "")}`
                  : classItem.class_subjects?.[0]?.grade_localization_key
                  ? ` • ${t(
                      classItem.class_subjects[0].grade_localization_key,
                      ""
                    )}`
                  : ""}
                {classItem.class_type ? ` • ${classItem.class_type}` : ""}
              </p>
              <p>
                {classItem.schedule_dates?.length > 0
                  ? deriveScheduleString(classItem.schedule_dates, locale)
                  : t("no_schedule_available", "No schedule available")}
              </p>
            </div>
          </div>
        </a>
      ))}
    </>
  );
};

export default List;
